import { asIsoDate } from 'components/shared/DatePicker/utils';
import type { ISalesCounterpart } from 'models/ISalesCounterpart';
import type { ProductFilter } from 'state/blotters/common/blotter.model';
import { dateNow, now } from 'utils/core/now';

export interface AddonManagmenetFormsRequest {
  issueDateOnAndAfter?: string;
  clientBdrId?: string;
  productType?: string;
}

export interface AddonManagementFilters {
  client?: ISalesCounterpart;
  issueDateOnAndAfter?: string;
  productFilter?: ProductFilter;
}

export interface AddonManagementWorkspaceState {
  isLoading: boolean;
  filters: AddonManagementFilters;
  error?: Error;
  isTradesFetchSuccessful?: boolean;
}

export const initialAddonManagementFilters: AddonManagementFilters = {
  issueDateOnAndAfter: asIsoDate(initializeIssueDateOnAndAfterDate()),
  productFilter: 'autocall',
};
export const initialAddonManagementWorkspaceState: AddonManagementWorkspaceState = {
  isLoading: true,
  filters: initialAddonManagementFilters,
  isTradesFetchSuccessful: undefined,
};

export function initializeIssueDateOnAndAfterDate(defaultPlusDays: number = 3) {
  const weekday = now().getDay();
  let totalPlusDays = 0;
  switch (weekday) {
    case 0: // Sunday
    case 1: // Monday
    case 2: // Tuesday
      totalPlusDays = defaultPlusDays;
      break;
    case 3: // Wednesday
    case 4: // Thursday
    case 5: // Friday
      totalPlusDays = defaultPlusDays + 2;
      break;
    case 6: // Saturday
      totalPlusDays = defaultPlusDays + 1;
      break;
    default:
      totalPlusDays = defaultPlusDays;
      break;
  }
  return new Date(dateNow() + 3600 * 1000 * 24 * totalPlusDays);
}
